/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import { errorToObject, v2 } from "@prftesp/cle-logger";
import errorCodes from "../../../../utility/errorCodes";
import {
	deleteStatusAlertsConfigs,
	listAgentStatuses,
	listStatusAlertsConfigs,
	updateStatusAlertsConfigs,
} from "../../services/StatusAlertsService";
import { statusAlertsActions } from "./reducer";

const COMPONENT_NAME = "Admin settingsManager/context/statusAlerts/actions";

export const fetchAgentStatusList = async (dispatch) => {
	try {
		dispatch({ type: statusAlertsActions.AGENT_STATUS_LIST_GET });
		const response = await listAgentStatuses();
		dispatch({ type: statusAlertsActions.AGENT_STATUS_LIST_GET_SUCCESS, payload: response });
	} catch (error) {
		v2.error(`Error while fetching status list`, {
			additionalData: { error: errorToObject(error) },
			componentName: COMPONENT_NAME,
			logCode: errorCodes.SAVE_EXTERNAL_CONTACTS_ERROR,
		});
		dispatch({
			type: statusAlertsActions.AGENT_STATUS_LIST_GET_ERROR,
			error: "Failed to load statuses.",
		});
	}
};

export const fetchStatusAlertsList = async (dispatch) => {
	try {
		dispatch({ type: statusAlertsActions.STATUS_ALERTS_LIST_GET });
		const response = await listStatusAlertsConfigs();
		dispatch({ type: statusAlertsActions.STATUS_ALERTS_LIST_GET_SUCCESS, payload: response.statusAlerts });
	} catch (error) {
		v2.error(`Error while fetching status alerts`, {
			additionalData: { error: errorToObject(error) },
			componentName: COMPONENT_NAME,
			logCode: errorCodes.SAVE_EXTERNAL_CONTACTS_ERROR,
		});
		dispatch({
			type: statusAlertsActions.STATUS_ALERTS_LIST_GET_ERROR,
			error: "Failed to load status alerts.",
		});
	}
};

export const saveRemoteStatusAlerts = async (dispatch, statusAlert) => {
	try {
		const isNew = statusAlert.new;
		dispatch({ type: statusAlertsActions.STATUS_ALERTS_LIST_UPDATE });
		await updateStatusAlertsConfigs(statusAlert);
		dispatch({ type: statusAlertsActions.STATUS_ALERTS_LIST_UPDATE_SUCCESS, isNewStatusAlert: !!isNew });
	} catch (error) {
		v2.error(`Error while updating status alerts`, {
			additionalData: { error: errorToObject(error) },
			componentName: COMPONENT_NAME,
			logCode: errorCodes.SAVE_EXTERNAL_CONTACTS_ERROR,
		});
		dispatch({
			type: statusAlertsActions.STATUS_ALERTS_LIST_UPDATE_ERROR,
			error: `Failed to ${statusAlert?.new ? "create" : "save"} status alert.`,
		});
	}
};

export const clearStatusAlertChanges = (dispatch) => {
	dispatch({ type: statusAlertsActions.STATUS_ALERTS_LIST_CLEAR_CHANGES });
};

export const updateStatusAlertChanges = (dispatch, statusAlerts) => {
	dispatch({ type: statusAlertsActions.STATUS_ALERTS_LIST_UPDATE_CHANGES, payload: statusAlerts });
};

export const updateStatusAlertAction = (dispatch, statusAlert) => {
	dispatch({ type: statusAlertsActions.STATUS_ALERT_UPDATE, payload: statusAlert });
};

export const removeStatusAlertAction = async (dispatch, statusAlertId) => {
	try {
		dispatch({ type: statusAlertsActions.STATUS_ALERTS_LIST_UPDATE });
		await deleteStatusAlertsConfigs(statusAlertId);
		dispatch({ type: statusAlertsActions.STATUS_ALERT_REMOVE, payload: statusAlertId });
	} catch (error) {
		v2.error(`Error while deleting status alerts`, {
			additionalData: { error: errorToObject(error) },
			componentName: COMPONENT_NAME,
			logCode: errorCodes.SAVE_EXTERNAL_CONTACTS_ERROR,
		});
		dispatch({
			type: statusAlertsActions.STATUS_ALERTS_LIST_UPDATE_ERROR,
			error: "Failed to remove status alert.",
		});
	}
};

export const addStatusAlertAction = (dispatch, statusAlert) => {
	dispatch({ type: statusAlertsActions.STATUS_ALERT_ADD_NEW, payload: statusAlert });
};
